import { useSelector } from 'react-redux'
import jwt_decode from 'jwt-decode'
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate
} from 'react-router-dom'
import moment from 'moment'
import {
  getTokenWithRefreshToken,
  getUserTokenWithRefreshToken
} from '../services/authService'

const isTokenExpired = (token) => {
  var decodedJwt = jwt_decode(token)
  if (decodedJwt === null) return true
  let value = moment().unix()
  return decodedJwt.exp <= value
}

export const isLoggedIn = async () => {
  let token = localStorage.getItem('access_token')
  if (token == null) {
    return false
  } else {
    let result = isTokenExpired(token)

    if (result) {
      let userType = localStorage.getItem('usertype')
      if (userType == 'HAdmin') {
        try {
          await getUserTokenWithRefreshToken()
          return true
        } catch (error) {
          localStorage.clear()
          return false
        }
      } else {
        try {
          await getTokenWithRefreshToken()
          return true
        } catch (error) {
          localStorage.clear()
          return false
        }
      }
    } else {
      return true
    }
  }
}

export const getUserNameFromToken = () => {
  let token = localStorage.getItem('access_token')
  if (token == null) {
    return ''
  }
  var decodedJwt = jwt_decode(token)
  if (decodedJwt === null) return ''
  return decodedJwt.username
}

export const getUserType = () => localStorage.getItem('usertype')

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const auth = useSelector((state) => state.authReducer)
  // if (!auth.user) {
  //   //history("/auth/sign-in");
  //   return <Navigate to="/auth/sign-in" />
  // }
  // else
  return children
}

export default AuthGuard
